import { ImageHelper } from "../../../utilities/image-helper";
import { PreviewKind } from "@radivision/graphql";

export const getPreviews = (item, list) => {
  if (item && item.previews) {
    const previews = {
      LOGO: ImageHelper.fetchOptimizedImageUrl({
        imageType: "PREVIEW",
        preview: {
          content: list?.previews,
          previewKind: PreviewKind.LOGO,
        },
        desiredDimensions: {
          containerWidthRatio: 5 / 12,
          numberOfItems: 1,
        },
        revision: item.revision,
      }),
      HERO: ImageHelper.fetchOptimizedImageUrl({
        imageType: "PREVIEW",
        preview: {
          content: item.previews,
          previewKind: PreviewKind.HERO,
        },
        desiredDimensions: {
          containerWidthRatio: 1,
          numberOfItems: 1,
        },
        revision: item.revision,
      }),
      BACKGROUND: ImageHelper.fetchOptimizedImageUrl({
        imageType: "PREVIEW",
        preview: {
          content: list?.previews,
          previewKind: PreviewKind.BACKGROUND,
        },
        desiredDimensions: {
          containerWidthRatio: 1,
          numberOfItems: 1,
        },
        revision: item.revision,
      }),
      A_ROLE: ImageHelper.fetchOptimizedImageUrl({
        imageType: "PREVIEW",
        preview: {
          content: list?.previews,
          previewKind: PreviewKind.A_ROLE,
        },
        desiredDimensions: {
          containerWidthRatio: 1,
          numberOfItems: 3,
        },
        revision: item.revision,
      }),
    };
    return previews;
  }
  return null;
};
